<template>
    <div>
        <Contractor v-if="$vuetify.breakpoint.xsOnly" />
        <LabeledCard v-if="$vuetify.breakpoint.smAndUp" :label="$t('Общая информация по договору')" class="pt-10">
            <Contractor />
        </LabeledCard>
    </div>
</template>

<script>
import Contractor from '@/components/Contractor.vue';
import LabeledCard from '@/components/ui/LabeledCard';

export default {
    name: 'Contracts',
    components: {
        Contractor,
        LabeledCard
    },
    computed: {},
    methods: {}
};
</script>
